import { Base } from "ui/Scripts/source/framework/base";

export interface ITaskPriorityListItem {
    id: string;
    companyId: string;
    taskTypeId: string;
    code: string;
    comment: string;
    sortOrder: number;
    activeState: number;
}

export class TaskPriorityListItem implements ITaskPriorityListItem {
    id: string;
    companyId: string;
    taskTypeId: string;
    code: string;
    comment: string;
    sortOrder: number;
    activeState: number;

    constructor();
    constructor(obj: ITaskPriorityListItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.companyId = obj && obj.companyId || "";
        this.taskTypeId = obj && obj.taskTypeId || "";
        this.code = obj && obj.code || "";
        this.comment = obj && obj.comment || "";
        this.sortOrder = obj && obj.sortOrder || 0;
        this.activeState = obj && obj.activeState || 0;
    }

    static sortTaskPriorityListItems(items: ITaskPriorityListItem[]): ITaskPriorityListItem[] {
        if (!items && items.length < 2) return items;
        return items.sort((a: ITaskPriorityListItem, b: ITaskPriorityListItem) => {
            if (!a || !b) return 0;
            let result = Base.numCompare(a.activeState, b.activeState);
            if (result !== 0) return result;
            result = Base.numCompare(a.sortOrder, b.sortOrder);
            if (result !== 0) return result;
            return Base.strCompare(a.code, b.code);
        });
    }
}